import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import { Typeahead } from 'react-bootstrap-typeahead';
import {
    Container, createMuiTheme, Toolbar, Typography, FormLabel, CssBaseline, Radio, RadioGroup,
    FormControlLabel, Checkbox, Button, TextField, Snackbar, Paper, Select, InputLabel, FormControl, AppBar, Grid, Backdrop, CircularProgress
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, DateTimePicker } from '@material-ui/pickers';
import { ValidatorForm } from 'react-material-ui-form-validator';
import SaveIcon from '@material-ui/icons/Save';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from "@material-ui/core/styles";
import MuiAlert from '@material-ui/lab/Alert';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from "../../apiAuthorization/httpService";
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext';
import { Context } from "../contexts/siteContext";
import { User } from '../contexts/userContext';
//import { TeamPro } from '../contexts/teamProContext';
import { TransactionTime } from '../common/transactionTime';
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import ServiceRecoveryList from '../serviceRecovery/serviceRecoveryList';
import VisitaionLogList from '../visitationLog/visitationLogList';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '10px 0px',
            width: '100%',
            padding: '10px'
        },
    },
    ddl: {
        width: '100%',
        margin: '10px 0px'
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    colorCode: {
        marginRight: '5px', color: 'inherit'
    },
    legend: {
        width: '16px', height: '16px', display: 'inline-block'
    },
    listIcon: {
        float: 'left',
        marginRight: '5px'
    },
    listIconRight: {
        marginLeft: '25px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }
}));

export default function TeamProList(props) {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { userDetail } = useContext(User);
    const { theme } = useContext(Theme);
    const currentTheme = createMuiTheme(GlobalTheme[theme]);
    const [requestorName, setRequestorName] = useState(userDetail.length === 0 ? '' : userDetail.PplPeoFirstName + " " + userDetail.PplPeoLastName);
    const [requestorPhone, setRequestorPhone] = useState(userDetail.length === 0 ? '' : userDetail.PplPeoHomePhone);
    const [requestorEmail, setRequestorEmail] = useState(userDetail.length === 0 ? '' : userDetail.PplPeoEmail);
    const [notes, setNotes] = useState('Task created from teamlead');
    const [taskClassList, setTaskClassList] = useState([]);
    const [selected, setSelected] = useState([]);
    const [taskClass, setTaskClass] = useState("");
    const [isStatDisplayed, setIsStatDisplayed] = useState(false);
    const [taskDefinitionFields, setTaskDefinitionFields] = useState([]);
    const [fields, setFields] = useState([]);
    const [HRCTaskModes, setHRCTaskModes] = useState([]);
    const [HRCTaskEquipments, setHRCTaskEquipments] = useState([]);
    const [MGMTRooms, setMGMTRooms] = useState([]);
    const requestDate = ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite)
    const [requestorStatus, setRequestorStatus] = useState('');
    const [noTask, setNoTask] = useState(false);
    const [radio, setRadio] = useState(false);
    const [open, setOpen] = useState(false);
    const [saved, setSaved] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const appRecoveryId = props.recoveryId ? props.recoveryId : 0;
    const [calledFromSR, setCalledFromSR] = useState(props.calledFromSR);
    const [facilityID, setFacilityID] = useState('');
    //const visitRecoveryId = props.visitRecoveryId ? props.visitRecoveryId : 0;
    //const [calledFromVL, setCalledFromVL] = useState(props.calledFromVL);
   
    const [task, setTask] = useState({
        chkIsolationPatient: false,
        TxtPatientName: '',
        TxtPatientDOB: null,
        Txtitem: '',
        CustomField1: '',
        CustomField2: '',
        CustomField3: '',
        CustomField4: '',
        CustomField5: '',
        Mode: '',
        Equipment: '',
        Panel1: [],
        Panel2: [],
        TxtScheduleDateEntry: null,
        TaskNumber: null,
        Status: "Unassigned"
    });

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseSuccess = () => {
        setOpenSuccess(false);
        setSelected([]);
        setSaved(false);
    };
   
    const getHRCTaskModes = () => {
        HttpService.post("/TeamPro/GetHRCTaskModes")
            .then((res) => {
                setHRCTaskModes(res);
            }, (error) => {
                console.log(error);
            });
    };

    const getHRCTaskEquipments = () => {
        HttpService.post("/TeamPro/GetHRCTaskEquipments")
            .then((res) => {
                setHRCTaskEquipments(res);
            }, (error) => {
                console.log(error);
            });
    };

    const getMobileListTaskClassesByFacilityID = (facilityID) => {
        HttpService.post("/TeamPro/GetMobileListTaskClassesByFacilityID", { FacilityID: facilityID })
            .then((res) => {
                if (res.error) {
                    setErrorMessage(res.message + ", please contact administrator.");
                    setOpen(true);
                    setBackDrop(false);
                }
                else {
                    let tasks = [];
                    let XMLParser = require('react-xml-parser');
                    let xml = new XMLParser().parseFromString(res.Content, "text/xml");
                    let functionalAreas = xml.getElementsByTagName("FunctionalArea");

                    for (let index = 0; index < functionalAreas.length; index++) {
                        if (functionalAreas[index].attributes["FunctionalAreaID"] === "2") {
                            let list = functionalAreas[index].getElementsByTagName("TaskClass");
                            for (let iIndex = 0; iIndex < list.length; iIndex++) {
                                tasks.push({ TaskClassID: list[iIndex].attributes["TaskClassID"], Brief: list[iIndex].attributes["Brief"] });
                            }
                        }
                    }

                    setTaskClassList(tasks);
                    if (tasks.length === 0) {
                        setNoTask(true);
                    }
                }
            });
    };

    const getTaskDefinitionFieldsForScreenByFacilityID = () => {
        setBackDrop(true);
        HttpService.post("/TeamPro/GetTaskDefinitionFieldsForScreenByFacilityID", { FacilityID: facilityID })
            .then((res) => {
                if (res.error) {
                    setErrorMessage(res.message + ", please contact administrator.");
                    setOpen(true);
                    setBackDrop(false);
                }
                else {
                    let XMLParser = require('react-xml-parser');
                    let xml = new XMLParser().parseFromString(res.Content, "text/xml");
                    let list = xml.getElementsByTagName("Class");
                    setFields(list);
                    setBackDrop(false);
                }
            }, (error) => {
                console.log(error);
                setBackDrop(false);
            });
    };   

    const getMobileListRoomsByFacilityID = () => {
        HttpService.post("/TeamPro/GetMobileListRoomsByFacilityID", { FacilityID: facilityID })
            .then((res) => {
                if (res.error) {
                    setErrorMessage(res.message + ", please contact administrator.");
                    setOpen(true);
                    setBackDrop(false);
                }
                else {
                    let XMLParser = require('react-xml-parser');
                    let xml = new XMLParser().parseFromString(res.Content, "text/xml");
                    let list = xml.getElementsByTagName('steLocations');
                    let rooms = [];
                    for (let index = 0; index < list.length; index++) {
                        rooms.push({
                            HirNode: list[index].attributes["HirNode"],
                            Title: list[index].attributes["Title"]
                        })
                    }
                    setMGMTRooms(rooms);
                }
            }, (error) => {
                console.log(error);
                setBackDrop(false);
            });
    };

    useEffect(() => {
        if (noTask === true) {
            setErrorMessage("No tasks in TeamPRO ID " + facilityID + ", please contact administrator.");
            setOpen(true);
        }

        // eslint-disable-next-line 
    }, [noTask]);

    useEffect(() => {
        if (defaultSite.IntegratedSystem.TaskMGMTSystemId)
            setFacilityID(defaultSite.IntegratedSystem.TaskMGMTSystemId);
         // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (facilityID) {
            getHRCTaskModes();
            getHRCTaskEquipments();
            getMobileListTaskClassesByFacilityID(facilityID);
            getTaskDefinitionFieldsForScreenByFacilityID();
            getMobileListRoomsByFacilityID();
            TransactionTime.begin('TeamPRO');
        }
        // eslint-disable-next-line 
    }, [facilityID]);

    const resetTask = () => {
        setTask({
            chkIsolationPatient: false,
            TxtPatientName: '',
            TxtPatientDOB: null,
            Txtitem: '',
            CustomField1: '',
            CustomField2: '',
            CustomField3: '',
            CustomField4: '',
            CustomField5: '',
            Mode: '',
            Equipment: '',
            Panel1: [],
            Panel2: [],
            TxtScheduleDateEntry: null,
            TaskNumber: null,
            Status: "Unassigned"
        });
        setTaskDefinitionFields([]);
        setIsStatDisplayed(false);
        setRequestorStatus("");
        setRadio(false);
    };

    const valueChanged = (evt) => {
        const value = evt.target.value;
        setTask({
            ...task,
            [evt.target.name]: value
        });
    };

    const dateChanged = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a")
        setTask({ ...task, TxtScheduleDateEntry: date });
    };

    const dobDateChanged = date => {
        date = moment(date).format("MM/DD/YYYY")
        setTask({ ...task, TxtPatientDOB: date });
    };

    const taskChanged = (item) => {
        let TaskClassID = item.target.value;
        var tasks, field = [];

        resetTask();
        setTaskClass(TaskClassID);

        for (let index = 0; index < fields.length; index++) {
            if (fields[index].attributes["ClassID"] === TaskClassID.toString()) {
                tasks = fields[index];
                setIsStatDisplayed(fields[index].attributes["IsStatDisplayed"] === "1");
                setRequestorStatus("Routine");
            }
        }

        if (tasks) {
            tasks = tasks.getElementsByTagName("Field");
            for (let index = 0; index < tasks.length; index++) {
                field.push({
                    ControlName: tasks[index].attributes["ControlName"],
                    ControlType: tasks[index].attributes["ControlType"],
                    CustomHeader: tasks[index].attributes["CustomHeader"],
                    Header: tasks[index].attributes["Header"],
                    TextLength: parseInt(tasks[index].attributes["TextLength"]),
                    Required: Boolean(parseInt(tasks[index].attributes["ForceField"])),
                    DisplayOrder: (tasks[index].attributes["CustomHeader"] === "Isolation Patient" ? 0 : parseInt(tasks[index].attributes["Displayorder"])),
                })
            }

            if (TaskClassID === "5119") // Area Clean task -> Add Destination field as it is mandatory
                field.push({ "ControlName": "Panel1", "ControlType": "TypeAhead", "CustomHeader": "Destination", "Header": "Destination", "TextLength": 4, "Required": true, "DisplayOrder": 1 })
        }
        setTaskDefinitionFields(field);
    };

    //const validate = () => {
    //    if (task.Panel1.length === 0) {
    //        setErrorMessage('Please enter the Destination.');
    //        setOpen(true);
    //        return false;
    //    }
    //    else
    //        return true;
    //}

    const updateTask = (e) => {

        //if (!validate())
        //    return;

        let model = {};
        model.roundId = 0;
        model.recoveryId = appRecoveryId;
        model.steHirNode = defaultSite.IntegratedSystem.TaskMGMTSystemId;
        model.StartLocation = task.Panel2.length > 0 ? task.Panel2[0].HirNode : '';
        model.DestinationLocation = task.Panel1.length > 0 ? task.Panel1[0].HirNode : '';
        model.Notes = notes;
        model.CustomField1 = task.CustomField1 || '';
        model.CustomField2 = task.CustomField2 || '';
        model.CustomField3 = task.CustomField3 || '';
        model.CustomField4 = task.CustomField4 || '';
        model.CustomField5 = task.CustomField5 || '';
        model.TaskClass = taskClass;
        model.TaskNumber = task.TaskNumber;
        model.ModeType = task.Mode.toString() || null;
        model.EquipmentType = task.Equipment.toString() || null;
        model.Item = task.Txtitem || '';
        model.FrequencyType = '';
        model.PatientName = task.TxtPatientName || '';
        model.PatientDOB = task.TxtPatientDOB || null;
        model.CostCodeID = '';
        model.PersistDay = '';
        model.IsolationPatient = task.chkIsolationPatient.toString();
        model.ScheduleDate = task.TxtScheduleDateEntry || null;
        model.RequestorName = requestorName;
        model.RequestorEmail = requestorEmail;
        model.RequestorPhone = requestorPhone;
        model.RequestDate = requestDate;
        model.TaskTypeID = "1";
        model.FunctionalArea = 2;
        model.Status = task.Status;
        model.CcnRequest = '';
        model.UpdatedBy = requestorName;
        model.AutoAssignCheck = false;
        model.ValidateRooms = false;
        model.SiteId = defaultSite.id;
        TransactionTime.end();
        TransactionTime.updateData(model);
        setBackDrop(true);

        HttpService.post("/TeamPro/updateTask", model)
            .then((res) => {
                setBackDrop(false);
                if (res.Content) {
                    if (res.Content.indexOf('valid') > -1) {
                        setErrorMessage("The destination is not valid, Please try again.");
                        setOpen(true);
                        return;
                    }

                    setOpenSuccess(true);
                    setSuccessMessage("A new task " + res.Content + " has been created successfully in HRC system.")
                    setCalledFromSR(false);
                    //setCalledFromVL(false);
                    setSaved(true);
                    resetTask();
                    setTaskClass("");
                } else if (res.Error) {
                    setErrorMessage(res.Error);
                    setOpen(true);
                }
            }, (error) => {
                console.log(error);
                setBackDrop(false);
            });
    };

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                {saved && appRecoveryId > 0 && props.appVisitId === undefined && <ServiceRecoveryList returnFromTP={true}
                    taskNumber={task.TaskNumber} siteLocation={selected} theme={currentTheme} />}
                {saved && appRecoveryId > 0 && props.appVisitId > -1 && <VisitaionLogList returnFromTP={true} showTeamPro={false}
                    taskNumber={task.TaskNumber} siteLocation={selected} theme={currentTheme} />}
                {(appRecoveryId === 0 || calledFromSR) && <>
                    <Backdrop className={classes.backdrop} open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} style={{ height: "100%" }}>
                        <Alert onClose={handleClose} severity="error">
                            {errorMessage}
                        </Alert>
                    </Snackbar>
                    <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleCloseSuccess} style={{ height: "100%" }}>
                        <Alert onClose={handleCloseSuccess} severity="success">
                            {successMessage}
                        </Alert>
                    </Snackbar>
                    <Container maxWidth="xl" height="100%" className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <Link to="/"><KeyboardBackspaceIcon /></Link>
                                <Typography variant="h6" className={classes.title}>&nbsp;TeamPRO</Typography><StatusIcon />
                                <Grid container justify="flex-end">
                                    <SmallMenu moduleName={"TeamPRO"} modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <ValidatorForm className={classes.root} autoComplete="off" onSubmit={updateTask} instantValidate={true}>
                                    <Paper>
                                        <div style={{ display: 'flex' }}>
                                            <div style={{ width: '50%' }}>
                                                <TextField style={{ margin: '10px 0px 10px 0px', width: '95%' }}
                                                    label="Name"
                                                    onChange={e => setRequestorName(e.target.value)}
                                                    name="name"
                                                    value={requestorName}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                                <br />
                                                <TextField style={{ margin: '10px 0px 10px 0px', width: '95%' }}
                                                    label="Phone"
                                                    onChange={e => setRequestorPhone(e.target.value)}
                                                    name="phone"
                                                    value={requestorPhone}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                                <br />
                                                <TextField style={{ margin: '10px 0px 10px 0px', width: '95%' }}
                                                    label="Email"
                                                    onChange={e => setRequestorEmail(e.target.value)}
                                                    name="email"
                                                    value={requestorEmail}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                            </div>
                                            <div style={{ width: '50%' }}>
                                                <TextField style={{ margin: '10px 0px 10px 0px', width: '100%' }}
                                                    label="Notes"
                                                    onChange={e => setNotes(e.target.value)}
                                                    name="notes"
                                                    multiline
                                                    rows={4}
                                                    value={notes}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                                {isStatDisplayed &&
                                                    <div style={{ display: 'flex', marginLeft: '10px', marginTop: '25px' }}>
                                                        <FormLabel component="legend" style={{ width: '10%' }}>Status</FormLabel>
                                                        <RadioGroup aria-label="cleanliness" name="cleanliness" value={requestorStatus} style={{ display: 'block', marginTop: '-12px' }}
                                                            onChange={(e) => {
                                                                setRequestorStatus(e.target.value);
                                                                setRadio(true);
                                                            }}>
                                                            {!radio && <FormControlLabel value="Routine" control={<Radio style={{ color: currentTheme.secondary }} />} checked={requestorStatus === "Routine"} label="Routine" />}
                                                            {!radio && <FormControlLabel value="Stat" control={<Radio style={{ color: currentTheme.secondary }} />} checked={requestorStatus === "Stat"} label="Stat" />}
                                                            {radio && <FormControlLabel value="Routine" control={<Radio style={{ color: currentTheme.secondary }} />} label="Routine" />}
                                                            {radio && <FormControlLabel value="Stat" control={<Radio style={{ color: currentTheme.secondary }} />} label="Stat" />}
                                                        </RadioGroup>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </Paper>
                                    <Paper>
                                        <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                            <InputLabel htmlFor="outlined-age-native-simple">Task</InputLabel>
                                            <Select
                                                native
                                                value={taskClass}
                                                onChange={(e) => taskChanged(e)}
                                                label="Task"
                                                size="small"
                                                required
                                            >
                                                <option aria-label="None" key="0" value="" />
                                                {
                                                    taskClassList.map((option, key) => {
                                                        return <option key={option.TaskClassID} value={option.TaskClassID} label={option.Brief} >{option.Brief}</option>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>

                                        {taskDefinitionFields.sort((a, b) => (a.DisplayOrder - b.DisplayOrder))
                                            .map((field, key) => (
                                                <div key={key}>
                                                    {field.ControlType === 'CheckBox' &&
                                                        <FormControlLabel
                                                            name={field.ControlName}
                                                            style={{ width: 'auto', marginLeft: '5px' }}
                                                            control={<Checkbox style={{ color: currentTheme.secondary }} checked={task[field.ControlName]} />}
                                                            label={field.CustomHeader}
                                                            labelPlacement="start"
                                                            required={field.Required}
                                                            onChange={e => setTask({ ...task, chkIsolationPatient: e.target.checked })}
                                                        />}
                                                    {field.ControlType === 'Text' && field.CustomHeader !== 'Patient DOB' &&
                                                        <TextField style={{ margin: '10px 0px 10px 0px', width: '100%' }}
                                                            label={field.CustomHeader}
                                                            onChange={e => valueChanged(e)}
                                                            name={field.ControlName}
                                                            required={field.Required}
                                                            value={task[field.ControlName]}
                                                            variant="outlined"
                                                            size="small"
                                                        />}
                                                    {field.ControlType === 'PickList' && field.CustomHeader === 'Mode' &&
                                                        <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                                            <InputLabel htmlFor="outlined-age-native-simple">{field.CustomHeader}</InputLabel>
                                                            <Select
                                                                native
                                                                onChange={e => valueChanged(e)}
                                                                name="Mode"
                                                                label={field.CustomHeader}
                                                                required={field.Required}
                                                            >
                                                                <option aria-label="None" key="0" value="" />
                                                                {
                                                                    HRCTaskModes.map((option, key) => {
                                                                        return <option key={option.name} value={option.id} label={option.name} >{option.name}</option>;
                                                                    })
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    }
                                                    {field.ControlType === 'PickList' && field.CustomHeader === 'Equipment' &&
                                                        <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                                            <InputLabel htmlFor="outlined-age-native-simple">{field.CustomHeader}</InputLabel>
                                                            <Select
                                                                native
                                                                onChange={e => valueChanged(e)}
                                                                name="Equipment"
                                                                label={field.CustomHeader}
                                                                required={field.Required}
                                                            >
                                                                <option aria-label="None" key="0" value="" />
                                                                {
                                                                    HRCTaskEquipments.map((option, key) => {
                                                                        return <option key={option.name} value={option.id} label={option.name} >{option.name}</option>;
                                                                    })
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    }
                                                    {field.ControlType === 'TypeAhead' &&
                                                        <>
                                                            <Typeahead style={{ margin: '10px 0px 10px 0px' }}
                                                                id="basic-example"
                                                                labelKey="Title"
                                                                name={field.ControlName}
                                                                onChange={e => setTask({ ...task, [field.ControlName]: e })}
                                                                options={MGMTRooms}
                                                                placeholder={field.CustomHeader === 'Start' ? field.CustomHeader + " Location " : field.CustomHeader + " Location *"}
                                                                selected={task[field.ControlName]}
                                                                inputProps={{ required: field.Required }}
                                                                defaultSelected={task[field.ControlName]}
                                                                renderMenuItemChildren={(option, key) => (
                                                                    <div className="dropdown-widget">
                                                                        <div className="left">{option.Title}</div>
                                                                    </div>
                                                                )}
                                                            />
                                                        </>
                                                    }
                                                    {(field.ControlType === 'DateTimeSplit') &&
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <DateTimePicker autoOk style={{ width: '100%', margin: '10px 0px 10px 0px' }}
                                                                inputVariant="outlined"
                                                                label="Schedule Date and Time"
                                                                format="MM/dd/yyyy hh:mm a"
                                                                size="small"
                                                                clearable
                                                                value={task[field.ControlName]}
                                                                inputadornmentprops={{ position: "start" }}
                                                                onChange={date => dateChanged(date)}
                                                                required={field.Required}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    }
                                                    {field.ControlType === 'Text' && field.CustomHeader === 'Patient DOB' &&
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker autoOk
                                                                style={{ width: '100%', margin: '10px 0px 10px 0px' }}
                                                                variant="inline"
                                                                inputVariant="outlined"
                                                                size="small"
                                                                id={field.ControlName}
                                                                format="MM/dd/yyyy"
                                                                disableFuture="true"
                                                                label={field.CustomHeader}
                                                                value={task[field.ControlName]}
                                                                onChange={date => dobDateChanged(date)}
                                                                required={field.Required}
                                                                InputAdornmentProps={{ position: "start" }}
                                                                PopoverProps={{
                                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                                }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    }
                                                </div>
                                            ))}
                                    </Paper>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        style={{ background: currentTheme.secondary, width: "100px", padding: '5px' }}
                                        startIcon={<SaveIcon />}
                                        disabled={ noTask || taskClass === "" }
                                        type="submit"
                                    >
                                        Save
                                    </Button>
                                </ValidatorForm>
                            </CardBody>
                        </Card>
                    </Container>
                </>
                }
            </ThemeProvider>
        </React.Fragment>
    )
}
